import React from 'react';

const RouteMap = ({ mapUrl }) => {
  if (!mapUrl) return null;

  return (
    <div className="route-map-container" style={{ width: '100%', height: '500px', margin: '20px 0' }}>
      <iframe
        src={mapUrl}
        width="100%"
        height="100%"
        style={{ border: 0 }}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        title="Route Map"
      />
    </div>
  );
};

export default RouteMap; 